import { render, staticRenderFns } from "./popup-power-info.vue?vue&type=template&id=c52c749c&scoped=true&"
import script from "./popup-power-info.vue?vue&type=script&lang=js&"
export * from "./popup-power-info.vue?vue&type=script&lang=js&"
import style0 from "./popup-power-info.vue?vue&type=style&index=0&id=c52c749c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52c749c",
  null
  
)

export default component.exports